import { render, staticRenderFns } from "./veJkyGain.vue?vue&type=template&id=6bed4109&scoped=true"
import script from "./veJkyGain.vue?vue&type=script&lang=js"
export * from "./veJkyGain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed4109",
  null
  
)

export default component.exports